export default "__VITE_ASSET__CVUqqL9___"